<template>
  <div class="page-content">
    <div class="container has-text-left">
      <div class="hero is-medium">
        <div class="hero-body">
          <h1 class="title is-1 has-text-grey">
            {{ $t("errorPage.errorCode") }}
          </h1>
          <h2 class="title is-3 has-text-grey">
            {{ $t("errorPage.errorDescription") }}
          </h2>
          <p class="title is-3 has-text-grey">{{ errorMessage }}</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="section">
        <a @click="goToStart()" class="is-size-3">{{
          $t("errorPage.backToHomeScreen")
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ErrorPage",
  computed: {
    ...mapGetters(["httpStatusCode"]),
    errorMessage() {
      let statusType = this.httpStatusCode.toString().substring(0, 1);
      switch (statusType) {
        case "4":
          return this.$i18n.t("errorPage.errorExplanation1");
        case "5":
          return this.$i18n.t("errorPage.errorExplanation2");
        default:
          return this.$i18n.t("errorPage.errorExplanation1");
          $;
      }
    },
  },
  methods: {
    goToStart() {
      this.$router.push("/");
    },
    fetchCMSData() {
      this.$store.dispatch("fetchCMSPage", { urlSlug: "/" });
    },
  },
  created() {
    this.fetchCMSData();
  },
};
</script>

<style scoped></style>
